import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceVerify {
    lookupService = new APIServiceLookUp();

    async verifyToken(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}verifyToken`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async profileUpdate(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}profileUpdate`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}